const ComLoading = ({ message = "Loading..." }) =>
    <div className="flex justify-center items-center min-h-[300px] flex-col">
        <div className="animate-spin rounded-full h-16 w-16 border-t-3 border-slate-700/50 mb-4"></div>
        <p className="text-base font-normal text-slate-500">{message}</p>
    </div>
export default ComLoading;